import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiTaskReportDateType, FiTaskReportType } from '../../fi-task-v2-report-enums';
import { ITask2ReportWidget, ITaskPeriodDateRange } from '../../fi-task-v2-report';
import { FiTaskV2ReportService } from '../../services/fi-task-v2-report.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiTaskV2ReportHelperService } from '../../services/fi-task-v2-report-helper.service';
import { IPeriodDateRange } from '@fi-shared/fi-time-range-menu/fi-time-range-menu';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiTask2ReportDateService } from '../../services/fi-task-v2-report-date.service';
import { Animations } from '@fi-shared/utils/animations';

// todo: remove this component
@Component({
    selector: 'fi-widget-details-header',
    templateUrl: './widget-details-header.component.html',
    styleUrls: ['./widget-details-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-widget-details-header' },
    standalone: false,
    animations: [Animations.fade],
})
export class WidgetDetailsHeaderComponent implements OnInit {
    @Input() widget: ITask2ReportWidget;
    @Input() isSaveFilterButtonsVisible: boolean;
    @Input() currentFilterId: number | string;
    @Output() toggleFilterVisibility = new EventEmitter<void>();
    @Output() onSaveWidget = new EventEmitter<void>();
    @Output() onSaveFilter = new EventEmitter<void>();

    protected taskDateRange: ITaskPeriodDateRange;
    protected timeIntervalOptions: INameIdObj[] = this.fiTaskV2ReportHelperService.taskReportDateOptions;
    protected readonly FiTaskReportDateType = FiTaskReportDateType;
    protected readonly FiTaskReportType = FiTaskReportType;

    constructor(
        private fiTaskV2ReportService: FiTaskV2ReportService,
        private appTextService: AppTextService,
        private fiTaskV2ReportHelperService: FiTaskV2ReportHelperService,
        private fiTask2ReportDateService: FiTask2ReportDateService,
    ) {}

    public ngOnInit(): void {
        this.taskDateRange = this.fiTask2ReportDateService.getDateRange(this.widget.Id);
    }

    protected back(): void {
        window.history.back();
    }

    protected onPeriodDateRangeChange(newRange: ITaskPeriodDateRange): void {
        this.fiTask2ReportDateService.setNewDateRange(this.widget.Id, newRange);
    }

    protected getReportName(): string {
        return this.fiTaskV2ReportHelperService.getTaskReportName(this.widget);
    }

    protected getSaveFilterLabel(): string {
        return this.appTextService.get(this.isCustomWidget() ? 'common.update_widget' : 'save_filter');
    }

    private isCustomWidget(): boolean {
        return !!this.widget.Name?.length;
    }

    protected saveWidget(): void {
        this.onSaveWidget.emit();
    }

    protected saveFilter(): void {
        this.onSaveFilter.emit();
    }

    protected toggleFilterContainerVisibility(): void {
        this.toggleFilterVisibility.emit();
    }
}
